exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shn-loading-page[data-v-15196f48]{z-index:9999;position:fixed;left:0;top:0;background:#fff;width:100%;height:100%}.shn-loading-page .shn-loading-mask[data-v-15196f48]{position:absolute;z-index:1000;margin:0;top:0;right:0;bottom:0;left:0}.shn-loading-page .shn-loading-main[data-v-15196f48]{z-index:1001;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center;font-weight:500;font-size:14px;color:#777}.shn-loading-page .shn-loading-main p[data-v-15196f48]{margin-top:20px}", ""]);

// exports
